<template>
  <div>
    <v-container>
      <template>
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            width="960"
            @click:outside="closeModal"
            :retain-focus="false"
          >
            <v-card class="custom-card" rounded="0">
              <v-toolbar color="secondary" class="white--text">
                <v-toolbar-title class="font-weight-bold">
{{ $t("ration.selectAnimals") }}                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text class="black--text pa-4 pt-8">
                <v-row>
                  <v-col cols="6">
                    <h2>{{ $t("ration.ungrouppedAnimals") }}      </h2>
                  </v-col>
                  <v-col cols="6">
                    <v-btn
                      class="float-right"
                      color="primary"
                      depressed
                      :disabled="this.selectedUngrouppedAnimal?.length == 0"
                      @click="createGroupModal"
                      >Create Group</v-btn
                    >
                  </v-col>
                </v-row>
                <!-- DATA TABLE HERE -->
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :items-per-page="10"
                  hide-default-footer
                  v-model="selectedUngrouppedAnimal"
                  show-select
                  :header-props="{
                    'sort-icon': 'mdi-unfold-more-horizontal',
                  }"
                  :loading="loading"
                  @pagination="paginationChanged"
                  @input="updateSelectedValues"
                >
                  <!-- SEARCH, FILTER & PAGINATION HERE -->
                  <template v-slot:top>
                    <div class="d-flex mt-5">
                      <v-text-field
                        prepend-inner-icon="mdi-magnify"
                        outlined
                        height="5px"
                        placeholder="Search"
                        dense
                        v-model="search"
                        class="shrink"
                      ></v-text-field>
                      <v-btn
                        :disabled="search.length < 1"
                        color="primary"
                        height="40"
                        width="40"
                        max-width="40"
                        outlined
                        class="ml-8"
                        @click="searchAnimals"
                      >
                        <v-icon>mdi-filter-outline</v-icon>
                      </v-btn>

                      <v-spacer></v-spacer>
                      <div class="py-3">
                        {{ tableOptions.page }} of {{ totalPages }}
                      </div>
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        :disabled="tableOptions.page <= 1"
                        @click="pageChange(false)"
                      >
                        <v-icon dark> mdi-chevron-left </v-icon>
                      </v-btn>
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        :disabled="tableOptions.page >= totalPages"
                        @click="pageChange(true)"
                      >
                        <v-icon dark> mdi-chevron-right </v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <template v-slot:progress>
                    <v-progress-linear
                      color="primary"
                      :height="8"
                      indeterminate
                    ></v-progress-linear>
                  </template>

                  <template v-slot:item.id="{ item }">
                    <div class="d-flex align-center">
                      <img class="pr-2" :src="item.avatar" />
                      {{ item.id }}
                    </div>
                  </template>
                  <template v-slot:item.breed="{ item }">
                    <div class="d-flex align-center">
                      {{ item.breed.name }}
                    </div>
                  </template>
                  <template v-slot:item.regDate="{ item }">
                    <div class="d-flex align-center">
                      {{
                        item.animalIdentification?.dateOfRegistration
                          | formatDate
                      }}
                    </div>
                  </template>
                  <template v-slot:item.tag="{ item }">
                    <div class="d-flex align-center">
                      {{
                        item.animalIdentification?.identificationMethods
                          ?.tagNumber
                      }}
                    </div>
                  </template>
                  <template v-slot:item.DOB="{ item }">
                    <div class="d-flex align-center">
                      {{ item?.birthOrigin?.dateOfBirth | formatDate }}
                    </div>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-btn
                      x-small
                      rounded
                      min-width="120"
                      color="green2"
                      depressed
                      class="primary--text border-active"
                      height="34"
                    >
                      {{ item.status }} <v-icon small>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:item.action="{item}">
                    <v-menu left :offset-x="true" rounded>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class="mt-1"
                          >mdi-dots-vertical
                        </v-icon>
                      </template>
                      <v-list class="user-menu" style="width: 200px">
                        <v-list-item @click="clickEditAnimal(item.id)" style="padding: 0">
                          <v-col cols="auto">
                            <v-btn small rounded color="green" depressed icon>
                              <v-icon size="large"> mdi-pencil </v-icon>
                            </v-btn>
                          </v-col>
                          <v-list-item-title style="font-size: 14px"
                            >Edit</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item style="padding: 0"  @click="archiveAnimal(item)">
                          <v-col cols="auto">
                            <v-btn x-small rounded color="red2" depressed fab>
                              <v-icon color="red">
                                mdi-trash-can-outline
                              </v-icon>
                            </v-btn>
                          </v-col>

                          <v-list-item-title style="font-size: 14px"
                            >Delete</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import { ungrouppedAnimal } from "@/graphql/Animals.gql";
import {
  archiveAnimal,
} from "@/graphql/Animals.gql";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
  apollo: {
    ungrouppedAnimal: {
      query: ungrouppedAnimal,
      update: (data) => data.ungrouppedAnimal.rows,
      fetchPolicy: "no-cache",
      variables() {
        return {
          type: "",
          searchPhrase: this.search,
          page: this.tableOptions.page,
          limit: this.tableOptions.limit,
        };
      },
      result({ data }) {
        this.loading = false;
        this.items = data.ungrouppedAnimal.rows;
        this.totalRecord = data.ungrouppedAnimal.totalCount;
        this.totalPages = Math.ceil(this.totalRecord / this.tableOptions.limit);
      },
    },
  },
  mounted() {
    this.loading = true;
  },
  data() {
    return {
      loading: false,
      selectedUngrouppedAnimal: [],
      totalRecord: 0,
      totalPages: 0,
      search: "",
      pageCount: 1,
      tableOptions: { page: 1, limit: 5 },
      headers: [
        {
          text: this.$t("ration.id"),
          align: "start",
          value: "id",
          class: "black--text",
        },
        {
          text: this.$t("ration.tag"),
          value: "tag",
          class: "black--text",
        },
        {
          text: this.$t("ration.dateOfBirth"),
          value: "DOB",
          class: "black--text",
        },
        {
          text: this.$t("ration.gender"),
          value: "gender",
          class: "black--text",
        },
        {
          text: this.$t("ration.breed"),
          value: "breed",
          class: "black--text",
        },
        {
          text: this.$t("ration.status"),
          value: "regDate",
          class: "black--text",
        },
        {
          text: "Status",
          value: "status",
          align: "center",
          class: "black--text",
        },

        {
          text: "",
          value: "action",
          align: "center",
          sortable: false,
          class: "black--text",
        },
      ],
      items: [],
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },

    createGroupModal() {
      if (!this.selectedUngrouppedAnimal?.length) {
        this.$notify({
          title: "Info!",
          text: "Please select an animal.",
          type: "info",
        });
        return;
      }
      this.$emit("createGroupName");
    },

    searchAnimals() {
      if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        // this.getTabletAnimalsData();
      } else {
        this.tableOptions.page = 1;
        // this.getAnimalsData();
      }
      this.loading = true;
      this.$apollo.queries.ungrouppedAnimal.refetch();
    },

    pageChange(t) {
      this.loading = true;
      if (t) this.tableOptions.page = Number(this.tableOptions.page) + 1;
      else this.tableOptions.page = Number(this.tableOptions.page) - 1;

      this.$router.replace({ query: { page: this.tableOptions.page } });
    },
    paginationChanged() {
      this.$router.replace({ query: { page: this.tableOptions.page } });
    },
    clickEditAnimal(id) {
      this.$router.push({
        name: "EditAnimal",
        params: { animal_number: id },
      });
    },
    
    archiveAnimal(item) {
      this.startLoading();
      this.$apollo
        .mutate({
          mutation: archiveAnimal,
          variables: {
            animalId: parseInt(item.id),
          },
        })
        .then(async ({ data }) => {
          if (data.archiveAnimal.success) {
            this.$notify({
            title: "Animal deleted successfully. ",
            text: "Animal deleted successfully.",
            type: "success",
          });
            this.closeModal();
            this.stopLoading();
          }
        })
        .catch((e) => {
          console.log("arc", e);
          this.stopLoading();
        });
    },
    updateSelectedValues() {
      this.$store.commit("setUngrouppedAnimal", this.selectedUngrouppedAnimal);
    },
  },
  mixins:[loadingMixin]
};
</script>

<style lang="scss" scoped>
.border-active {
  border: 1px solid green !important;
}

.border-deactivated {
  border: 1px solid red !important;
}
</style>
